<template>
<div id="knowledge-base-category-page">
    <!--CURSOS-->
    <vs-tabs alignment="fixed" color="dark">
        <vs-tab :label=' "Activos ( " +  cursosActivos.length + " )"' class="mt-4">
            <div v-if="menu == 0">
                <vs-button class="m-1" type="border" @click="nuevo()">Agregar curso</vs-button>
                <div class="containerCurso mt-3" v-if="menu == 0">
                    <div class="profile-card" v-for="section in cursosActivos" :key="section.id">
                        <div class="card-header">
                            <div class="pic">
                                <img src="../estudiantes/img/curso.png" alt="">
                            </div>
                            <div class="name">{{ section.materia }}</div>
                            <div class="desc">Grado: {{ section.grado }}</div>
                            <!-- <span class="contact-btn cursor-pointer" @click="showModal = true; tmpSeccion= section;abrirCurso(section);">Ver curso</span> -->
                        </div>
                        <div class="card-footer">
                            <div class="numbers">
                                <div class="item">
                                    <span>{{ section.paralelo }}</span>
                                    Paralelo
                                </div>
                                <div class="border"></div>
                                <div class="item">
                                    <h4><b>{{ section.codigo }}</b></h4>
                                    Código
                                </div>
                                <div class="border"></div>
                                <div class="item">
                                    <span>{{ section.updated_at.substring(0,10) }}</span>
                                    Creado
                                </div>
                            </div>
                        </div>
                        <!--ACCIONES-->
                        <div class="caja-pie" style="display:flex;width:100%;justify-content:center;">
                            <div>
                                <vs-button color="#2078CB" type="line" icon-pack="feather" icon="icon-eye" @click="verClase(section)" class="m-2">Ver</vs-button>
                            </div>
                            <div>
                                <vs-button color="success" type="line" icon-pack="feather" icon="icon-edit" @click="id=section.idcurso;popupAddCurso = true;" class="m-2">Editar</vs-button>
                            </div>
                            <div>
                                <vs-button color="danger" type="line" icon-pack="feather" icon="icon-trash" @click="idcurso = section.idcurso;eliminar();" class="m-2">Desactivar</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vs-tab>
        <vs-tab :label=' "Inactivos ( " +  cursosInactivos.length + " )"' class="mt-4">
            <vs-table max-items="30" search pagination :data="cursosInactivos">
                <template slot="thead">
                    <vs-th>Código</vs-th>
                    <vs-th>Asignatura</vs-th>
                    <vs-th>Paralelo</vs-th>
                    <vs-th>Actualizado</vs-th>
                    <vs-th>Acción</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>{{ tr.codigo }}</vs-td>
                        <vs-td>{{ tr.materia }}</vs-td>
                        <vs-td>{{ tr.paralelo }}</vs-td>
                        <vs-td>{{ tr.updated_at  }}</vs-td>
                        <vs-td>
                            <vs-button color="dark" @click="idcurso = tr.idcurso; reactivar();">Reactivar</vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </vs-tab>
    </vs-tabs>

    <!--RECURSOS-->
    <div v-if="menu == 1">
        <vs-button color="primary" class="p-2" type="flat" @click="menu = 0;$emit('removeItems',true)">← ir a cursos</vs-button>
        <!--SUBMENU-->
        <nav class="breadcrumbs mt-3">
            <a href="#recursos" class="breadcrumbs__item  menuSelectSubMenu activeBtn submenu0" @click="submenu = 0;estadoMenu();">Recursos del curso </a>
            <a href="#TareasEnviadas" class="breadcrumbs__item  menuSelectSubMenu submenu1" @click="getRecurso();submenu = 1;estadoMenu();">Tareas o recursos enviados</a>
        </nav>
        <!--SUBMENU COMPONENTS-->
        <div>
            <!--CARDS DE RECURSOS-->
            <div v-if="submenu == 0">
                <recursosDocenteVue :codigoCurso="codigoCurso" externo="0" />
            </div>
            <!--TAREAS ENVIADAS-->
            <div v-if="submenu == 1">
                <ListadoRecursoEstudianteVue :codigoCurso="codigoCurso" :arregloRecursos="arregloRecursos" />
            </div>
        </div>
    </div>
    <!--MODALES-->
    <vs-popup title="Cursos" :active.sync="popupAddCurso">
        <nuevoVue v-if="popupAddCurso" :id="id" @changeReturn="changeReturn" @changeRecharge="getCurso" />
    </vs-popup>
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
// import vSelect from 'vue-select'
Vue.use(axios)
import nuevoVue from './nuevo.vue'
import recursosDocenteVue from './recursosDocente.vue'
import ListadoRecursoEstudianteVue from '../estudiantes/recursos/ListadoRecursoEstudiante.vue'
export default {
    data() {
        return {
            id: 0,
            popupAddCurso: false,
            curso: [],
            usuario: [],
            idcurso: '',
            currentx: 1,
            otraActivo: false,
            datoU: '',
            idusuario: '',
            grupo_usuario: '',
            sendCurso: {},
            menu: 0,
            codigoCurso: '',
            submenu: 0,
            arregloRecursos: [],
            cursosActivos: [],
            cursosInactivos: [],
            activa_desactiva: 0, //0 inactivo , 1 activo
            mensaje: '',
        }
    },
    created() {
        this.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
        this.grupo_usuario = this.usuario.id_group;
        this.idusuario = this.usuario.idusuario;
        this.institucion = this.usuario.institucion_idInstitucion;
        if (this.grupo_usuario == 10) { //director
            this.datoU = JSON.parse(localStorage.getItem('datoUser'))
            // console.log(this.datoU)
            this.idusuario = this.datoU.idusuario;
        }
        this.getRecurso()
    },
    computed: {},
    methods: {
        getRecurso() {
            let me = this;
            me.$vs.loading()
            var url = ""
            url = this.$server_url + 'recursos?recursosEstudiante=yes&codigoCurso=' + me.codigoCurso + '&id_group=' + me.usuario.id_group
            this.$http.get(url)
                .then(res => {
                    me.$vs.loading.close()
                    let datos = res.data
                    me.arregloRecursos = datos
                })
                .catch(error => {
                    console.log(error)
                    me.$vs.loading.close()
                })
        },
        getCurso() {
            let me = this;
            me.popupAddCurso = false;
            me.$vs.loading()
            this.$http.get(this.$server_url + 'curso_libro_docente?id_usuario=' + me.idusuario + '&id_libro=' + localStorage.idlibro + '&periodo_id=' + localStorage.periodo_id)
                .then(function (response) {
                    me.curso = response.data;
                    me.cursosActivos = me.curso.filter(val => val.estado == 1);
                    me.cursosInactivos = me.curso.filter(val => val.estado == 0);
                    // console.log(me.cursosActivos, me.cursosInactivos)
                    me.$vs.loading.close()
                })
                .catch(() => {
                    me.$vs.loading.close()
                })
        },
        verClase(section) {
            let me = this
            me.codigoCurso = section.codigo
            localStorage.nombrelibroSelec = section.nombre + ' ' + section.seccion;
            localStorage.nombre_curso = section.materia + ' Curso: ' + section.grado + ' ' + section.paralelo;
            localStorage.codigo = section.codigo;
            localStorage.idcurso = section.idcurso;
            this.menu = 1
            me.$emit('ChangeCodigo', section.codigo)
        },
        nuevo() {
            let me = this;
            me.popupAddCurso = true;
            localStorage.idcurso = '';
        },
        editar(idcurso) {
            localStorage.idcurso = idcurso;
            this.$router.push(`/docente/curso/editar`);
        },
        eliminar() {
            let me = this;
            localStorage.idcurso = me.idcurso;
            me.activa_desactiva = 0; //desactivas curso
            me.mensaje = 'Curso desactivado correctamente';
            me.$vs.dialog({
                color: 'danger',
                title: 'Desactivar',
                text: 'Seguro desea desactivar este curso?',
                accept: this.acceptAlert,
                acceptText: 'Si, desactivar',
            })
        },
        reactivar() {
            let me = this;
            localStorage.idcurso = me.idcurso;
            me.activa_desactiva = 1; //activar curso
            me.mensaje = 'Curso activado correctamente';
            me.$vs.dialog({
                color: 'success',
                title: 'Reactivar',
                text: 'Seguro desea ACTIVAR este curso?',
                accept: this.acceptAlert,
                acceptText: 'Si, activar',
            })
        },
        acceptAlert() {
            let me = this;
            let formData = new FormData();
            formData.append("idcurso", me.idcurso);
            formData.append("estado", me.activa_desactiva);
            this.$http.post(this.$server_url + "activa_desactiva_Curso", formData)
                .then(function () {
                    // console.log(response.data)
                    me.$vs.notify({
                        color: 'success',
                        title: 'Aceptado',
                        text: me.mensaje
                    })
                    me.getCurso();
                })
                .catch(() => {
                    me.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        text: 'Error al realizar el proceso'
                    })
                })
        },
        changeReturn() {
            let me = this;
            me.popupAddCurso = false;
        },
        estadoMenu() {
            let me = this;
            localStorage.setItem('menuSelectSubMenu', me.menu)
            var divs = document.querySelectorAll(".menuSelectSubMenu");
            for (var i = 0; i < divs.length; i++) {
                divs[i].classList.remove("activeBtn");
            }
            const container = document.querySelector(".submenu" + me.submenu);
            container.classList.add("activeBtn");
        },
    },
    components: {
        // 'v-select': vSelect,
        nuevoVue,
        recursosDocenteVue,
        ListadoRecursoEstudianteVue,
    },
    mounted() {
        let me = this
        // localStorage.removeItem("idcurso")
        me.getCurso();
    }
}
</script>

<style scoped>
/**ESTILOS CURSOS CARD */
* {
    margin: 0;
    padding: 0;
    font-family: 'Inter', 'sans-serif';
    box-sizing: border-box;
    text-decoration: none;
}

.containerCurso {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100% !important;
}

.profile-card {
    width: 400px;
    text-align: center;
    border-radius: 8px;
    overflow: hidden;
    margin: 10px;
    border-radius: 10px;
    box-shadow: #bbb 6px 8px;
}

.card-header {
    background: #2c3a47;
    padding: 20px;
}

.pic {
    display: inline-block;
    padding: 3px;
    background: linear-gradient(130deg, #74b9ff, #e66767);
    margin: auto;
    border-radius: 50%;
    background-size: 150% 150%;
    animation: animated-gradient 2s linear infinite;
}

@keyframes animated-gradient {
    25% {
        background-position: left bottom;
    }

    50% {
        background-position: right bottom;
    }

    75% {
        background-position: right top;
    }

    100% {
        background-position: left top;
    }
}

.pic img {
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 50%;
}

.name {
    color: #f2f2f2;
    font-size: 28px;
    font-weight: 600;
    margin: 10px 0;
}

.desc {
    font-size: 18px;
    color: #e66767;
}

.sm {
    display: flex;
    justify-content: center;
    margin: 20px 0;
}

.sm a {
    color: #f2f2f2;
    width: 56px;
    font-size: 22px;
    transition: .3s linear;
}

.sm a:hover {
    color: #e66767;
}

.contact-btn {
    display: inline-block;
    padding: 12px 50px;
    color: #E5834B !important;
    border: 2px solid #e66767;
    border-radius: 6px;
    margin-top: 16px;
    transition: .3s linear;
}

.contact-btn:hover {
    background: #e66767;
    color: #f2f2f2 !important;
}

.card-footer {
    background: #f4f4f4;
    padding: 20px 10px;
}

.numbers {
    display: flex;
    align-items: center;
}

.item {
    flex: 1;
    text-transform: uppercase;
    font-size: 11px;
    color: #e66767;
}

.item span {
    display: block;
    color: #2c3a47;
    font-size: 13px;
    font-weight: 600;
}

.border {
    width: 1px;
    height: 30px;
    background: #bbb;
}

/**ESTILOS SUB MENU */
/*SUBMENU*/
.activeBtn {
    background-color: #1cbeb3;
    color: white !important;
}

/**ESTILOS SUB MENU */
.breadcrumbs {
    border: 1px solid #cbd2d9;
    border-radius: 0.3rem;
    display: inline-flex;
    overflow: hidden;
}

.breadcrumbs__item {
    outline: none;
    padding: 0.75em 0.75em 0.75em 1.25em;
    position: relative;
    text-decoration: none;
    transition: background 0.2s linear;
    color: black;
}

.breadcrumbs__item:hover:after,
.breadcrumbs__item:hover {
    background: #2263a4;
    color: white;
}

.breadcrumbs__item:focus:after,
.breadcrumbs__item:focus,
.breadcrumbs__item.is-active:focus {
    background: #1cbeb3;
    color: #fff;
}

.breadcrumbs__item:after,
.breadcrumbs__item:before {
    background: white;
    bottom: 0;
    clip-path: polygon(50% 50%, -50% -50%, 0 100%);
    content: "";
    left: 100%;
    position: absolute;
    top: 0;
    transition: background 0.2s linear;
    width: 1em;
    z-index: 1;
}

.breadcrumbs__item:before {
    background: #cbd2d9;
    margin-left: 1px;
}

.breadcrumbs__item:last-child {
    border-right: none;
}

.breadcrumbs__item.is-active {
    background: #edf1f5;
}
.caja-pie{
    background-color: #e4dede;
}
</style>
